import { List as ImmutableList } from 'immutable';
import Sender from '../records/Sender';
export const buildSenders = (senders = []) => {
  return ImmutableList().withMutations(mutableList => {
    ImmutableList(senders).forEach(sender => {
      mutableList.push(Sender(sender));
    });
  });
};